import DateFnsUtils from '@date-io/date-fns';
import { Button, ButtonGroup, Grid, Paper, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import ListableCard from "../../../components/listable-card/ListableCard";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import CustomizedSnackbars from "../../../components/snackbar/Snackbar";
import TitledCard from "../../../components/titled-card/TitledCard";
import { ContentPickerModal } from "../../../containers/content-picker-modal/ContentPickerModal";
import { TargetGroupPickerModal } from "../../../containers/target-group-picker-modal/TargetGroupPickerModal";
import { getCampaign, resetLocalCampaign, updateLocalCampaign, updateCampaign, endCampaignEarly } from "../../../state/actions/CampaignActions";
import { getMustSellSkusForIds } from "../../../state/actions/MustSellActions";
import { getGroupsWithIds } from "../../../state/actions/GroupActions";
import { getFormsForIds } from "../../../state/actions/FormsActions";
import { getPriceLists } from "../../../state/actions/PriceListsActions";
import { getFilesForIds } from "../../../state/actions/FileDownloadActions";
import { getTargetGroupsForIds } from "../../../state/actions/TargetGroupActions";
import { getCustomerFlagsForIds } from "../../../state/actions/CustomerFlagActions";
import { getObjectives } from "../../../state/actions/ObjectiveActions";
import { getDashboardLayoutsByIds } from "../../../state/actions/DashboardLayoutActions";


import { getContentType } from "../../../state/constants/ContentType";
import styles from "./CampaignsPage.module.scss";
import AlertDialog from '../../../components/alert-dialog/AlertDialog';
import { withTranslation } from 'react-i18next';
import { ObjectiveType } from '../../../state/constants/ObjectiveConstants';

// Update if more content types added
const contentCallsMadeValue = 8;

class ViewCampaignPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            campaignId: "",

            loading: false,
            campaign: {},
            isEditing: false,

            selectedTargetGroups: [],
            selectedTargetContent: [],

            modelTypeData: ["Customers", "Products"],
            snackbarOpen: false,
            targetGroupModalOpen: false,
            targetGroupsLoading: false,
            targetContentModalOpen: false,
            targetContentLoading: false,
            endCampaignModalOpen: false,
            contentCallsMade: 0
        }
    }

    componentDidMount() {
        this.setState({ loading: true, campaignId: this.props.match.params.campaignId, targetGroupsLoading: true, targetContentLoading: true });
        const ContentType = getContentType()

        this.props.getCampaign(this.props.match.params.campaignId, () => {
            this.setState({
                loading: false,
                campaign: this.props.currentCampaign,
                contentCallsMade: contentCallsMadeValue
            });

            this.props.getTargetGroupsForIds(this.props.currentCampaign.TargetGroups, () => {
                this.setState({
                    targetGroupsLoading: false
                })
            });

            const mustSellIds = [];
            const fileIds = [];
            const productGroupIds = [];
            const formIds = [];
            const objectiveIds = [];
            const customerFlagIds = [];
            const priceLists = [];
            const dashboardLayouts = [];

            this.props.currentCampaign.TargetContent.forEach(item => {
                if (item.Type === ContentType.MustSell.key) { mustSellIds.push(item.Id) }

                if (item.Type === ContentType.Image.key || item.Type === ContentType.File.key) { fileIds.push(item.Id) }

                if (item.Type === ContentType.ProductGroup.key) { productGroupIds.push(item.Id) }

                if (item.Type === ContentType.Forms.key) { formIds.push(item.Id) }

                if (item.Type === ContentType.Objectives.key) { objectiveIds.push(item.Id) }

                if (item.Type === ContentType.CustomerFlag.key) { customerFlagIds.push(item.Id) }

                if (item.Type === ContentType.PriceLists.key) { priceLists.push(item.Id) }

                if (item.Type === ContentType.DashboardLayouts.key) { dashboardLayouts.push(item.Id) }
            })

            if (mustSellIds.length > 0) {
                this.props.getMustSellSkusForIds(mustSellIds, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (fileIds.length > 0) {
                this.props.getFilesForIds(fileIds, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (productGroupIds.length > 0) {
                this.props.getGroupsWithIds(productGroupIds, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (formIds.length > 0) {
                this.props.getFormsForIds(formIds, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (objectiveIds.length > 0) {
                this.props.getObjectives([ObjectiveType().admin.key], () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (priceLists.length > 0) {
                this.props.getPriceLists(false, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (customerFlagIds.length > 0) {
                this.props.getCustomerFlagsForIds(customerFlagIds, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }

            if (dashboardLayouts.length > 0) {
                this.props.getDashboardLayoutsByIds(dashboardLayouts, () => {
                    this.incrementContentCallsMade()
                })
            } else {
                this.incrementContentCallsMade()
            }
        });
    }

    incrementContentCallsMade() {
        this.setState(state => { return { targetContentLoading: !(state.contentCallsMade - 1 === 0), contentCallsMade: state.contentCallsMade - 1 } })
    }

    componentDidUpdate() {
        if (
            JSON.stringify(this.state.campaign) !==
            JSON.stringify(this.props.currentCampaign)
        ) {
            this.setState({
                campaign: this.props.currentCampaign,
            });
        }
    }

    componentWillUnmount() {
        this.props.resetLocalCampaign(() => { })
    }

    getTargetGroupsForIds(itemIds) {
        if (itemIds !== undefined) {
            return itemIds.map(itemId => {
                var item = {};
                this.state.modelTypeData.forEach(modelType => {
                    if (this.props.targetGroups[modelType] !== undefined) {
                        const targetGroup = this.props.targetGroups[modelType][itemId];

                        if (targetGroup !== undefined) {
                            item = { id: targetGroup.id, secondaryText: modelType, Name: targetGroup.DisplayName };
                        }
                    }
                });
                return item;
            });
        }

        return [];
    }

    handleTargetGroupSelection(selectedItems) {
        const selectedTargetGroups = this.getTargetGroupsForIds(selectedItems);

        var campaign = Object.assign({}, this.state.campaign);

        selectedTargetGroups.forEach(group => {
            campaign.TargetGroups.push(group.id);
        });

        // campaign.TargetGroups = selectedTargetGroups.map(targetGroup => targetGroup.id)
        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetGroups: selectedTargetGroups,
                targetGroupModalOpen: false
            });
        });
    }

    handleTargetGroupDeletion(selectedItems) {
        var campaign = Object.assign({}, this.state.campaign);
        campaign.TargetGroups = campaign.TargetGroups.filter(targetGroup => !selectedItems.includes(targetGroup));
        const selectedTargetGroups = this.state.selectedTargetGroups.filter(targetGroup => !selectedItems.includes(targetGroup.id));
        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetGroups: selectedTargetGroups
            });
        });
    }

    getTargetContentForIds(itemIds) {
        const ContentType = getContentType()

        if (itemIds !== undefined) {
            return itemIds.map(itemId => {
                const targetContent = this.props.files[itemId];
                const mustSellContent = this.props.mustSells[itemId];
                const productGroups = this.props.groups[itemId];
                const forms = this.props.forms[itemId];
                const objectives = this.props.objectives[itemId];
                const customerFlags = this.props.customerFlags[itemId];
                const priceLists = this.props.priceLists[itemId];
                const dashboardLayouts = this.props.dashboardLayouts[itemId]

                if (targetContent !== undefined) {
                    return { id: targetContent.id, type: targetContent.Type, secondaryText: targetContent.Type, Name: targetContent.DisplayName };
                }

                if (mustSellContent !== undefined) {
                    return { id: mustSellContent.id, type: ContentType.MustSell.key, secondaryText: ContentType.MustSell.value, Name: mustSellContent.Name };
                }

                if (productGroups !== undefined) {
                    return { id: productGroups.id, type: ContentType.ProductGroup.key, secondaryText: ContentType.ProductGroup.value, Name: productGroups.Name };
                }

                if (forms !== undefined) {
                    return { id: forms.id, type: ContentType.Forms.key, secondaryText: ContentType.Forms.value, Name: forms.Name };
                }

                if (objectives !== undefined) {
                    return { id: objectives.id, type: ContentType.Objectives.key, secondaryText: ContentType.Objectives.value, Name: objectives.Title };
                }

                if (customerFlags !== undefined) {
                    return { id: customerFlags.id, type: ContentType.CustomerFlag.key, secondaryText: ContentType.CustomerFlag.value, Name: customerFlags.Name };
                }

                if (priceLists !== undefined) {
                    return { id: priceLists.id, type: ContentType.PriceLists.key, secondaryText: ContentType.PriceLists.value, Name: priceLists.Name };
                }

                if (dashboardLayouts !== undefined) {
                    return { id: dashboardLayouts.id, type: ContentType.DashboardLayouts.key, secondaryText: ContentType.DashboardLayouts.value, Name: dashboardLayouts.id };
                }

                return { id: itemId, Name: this.props.t('campaign.unknown-deleted-content'), notClickable: true };
            });
        }

        return [];
    }

    getRouteForTargetContent(id) {
        const ContentType = getContentType()

        if (id) {
            const targetContent = this.state.campaign.TargetContent;

            const item = targetContent.find(item => item.Id === id);

            switch (item.Type) {
                case ContentType.File.key:
                case ContentType.Image.key: {
                    return this.props.history.push(`/content`);
                }

                case ContentType.MustSell.key: {
                    return this.props.history.push(`/must-sell-skus/${item.Id}`);
                }

                case ContentType.ProductGroup.key: {
                    return this.props.history.push(`/product-groupings/${item.Id}`);
                }

                case ContentType.Forms.key: {
                    return this.props.history.push(`/forms/edit/${item.Id}`);
                }

                case ContentType.Objectives.key: {
                    return this.props.history.push(`/objectives/${item.Id}`);
                }

                case ContentType.CustomerFlag.key: {
                    // Customer flags have no dedicated view page
                    return this.props.history.push(`/customer-flags`);
                }

                case ContentType.PriceLists.key: {
                    return this.props.history.push(`/price-lists/${item.Id}`);
                }

                case ContentType.DashboardLayouts.key: {
                    return this.props.history.push(`/dashboard-layouts/${item.Id}`)
                }

                default:
                    return null
            }
        }
        return null
    }

    handleTargetContentSelection(selectedItems) {
        const selectedTargetContent = this.getTargetContentForIds(selectedItems);
        var campaign = Object.assign({}, this.state.campaign);

        selectedTargetContent.forEach(content => {
            campaign.TargetContent.push({ Type: content.type, Id: content.id, DisplayName: content.Name });
        });
        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetContent: selectedTargetContent,
                targetContentModalOpen: false
            });
        });
    }

    handleTargetContentDeletion(selectedItems) {
        var campaign = Object.assign({}, this.state.campaign);
        campaign.TargetContent = campaign.TargetContent.filter(targetContent => !selectedItems.includes(targetContent.Id));
        const selectedTargetContent = this.state.selectedTargetContent.filter(targetContent => !selectedItems.includes(targetContent.id));

        this.props.updateLocalCampaign(campaign, () => {
            this.setState({
                campaign: this.props.currentCampaign,
                selectedTargetContent: selectedTargetContent
            });
        });
    }

    renderData() {
        return (
            <div className={styles.contentGrid}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Paper>
                            <TitledCard
                                title={this.props.t('common.display-name')}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    disabled={!this.state.isEditing}
                                    classes={{ root: styles.textField }}
                                    label={this.props.t('common.display-name')}
                                    value={this.props.currentCampaign.DisplayName}
                                    onChange={(event) => {
                                        var campaign = Object.assign({}, this.state.campaign);
                                        campaign.DisplayName = event.target.value
                                        this.props.updateLocalCampaign(campaign, () => {
                                            this.setState({ campaign: this.props.currentCampaign });
                                        });
                                    }}
                                    variant="outlined"
                                    margin="dense"
                                />
                            </TitledCard>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <TitledCard
                                title={this.props.t('common.start-date')}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="dense"
                                        disabled={!this.state.isEditing}
                                        classes={{ root: styles.datePicker }}
                                        disableToolbar
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/yyyy"
                                        label={this.props.t('campaign.select-start-date')}
                                        value={this.state.campaign.StartDate}
                                        onChange={(date) => {
                                            var campaign = Object.assign({}, this.state.campaign);
                                            campaign.StartDate = date
                                            this.props.updateLocalCampaign(campaign, () => {
                                                this.setState({ campaign: this.props.currentCampaign });
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </TitledCard>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <TitledCard
                                title={this.props.t('common.end-date')}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="dense"
                                        disabled={!this.state.isEditing}
                                        classes={{ root: styles.datePicker }}
                                        disableToolbar
                                        variant="inline"
                                        inputVariant="outlined"
                                        format="dd/MM/yyyy"
                                        label={this.props.t('campaign.select-end-date')}
                                        value={this.state.campaign.EndDate}
                                        onChange={(date) => {
                                            var campaign = Object.assign({}, this.state.campaign);
                                            campaign.EndDate = date
                                            this.props.updateLocalCampaign(campaign, () => {
                                                this.setState({ campaign: this.props.currentCampaign });
                                            });
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </TitledCard>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <ListableCard
                                actionButton={[
                                    <Button
                                        onClick={() => this.setState({ targetGroupModalOpen: true })}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        {this.props.t('target-group.select')}
                                    </Button>
                                ]}
                                disabled={!this.state.isEditing}
                                onClick={(id) => this.props.history.push(`/target-groups/${id}`)}
                                addLabel={this.props.t('target-group.add-target-group')}
                                isLoading={this.state.targetGroupsLoading}
                                title={this.props.t('target-group.target-groups')}
                                emptyPlaceholder={this.props.t('campaign.none-added')}
                                handleDelete={(data) => this.handleTargetGroupDeletion(data)}
                                data={this.state.campaign.TargetGroups == null ? [] : this.getTargetGroupsForIds(this.state.campaign.TargetGroups)}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Paper>
                            <ListableCard
                                actionButton={[
                                    <Button
                                        onClick={() => this.setState({ targetContentModalOpen: true })}
                                        variant="outlined"
                                        color="secondary"
                                    >
                                        {this.props.t('campaign.select')}
                                    </Button>
                                ]}
                                disabled={!this.state.isEditing}
                                onClick={(id) => this.getRouteForTargetContent(id)}
                                addLabel={this.props.t('campaign.add-content')}
                                isLoading={this.state.targetContentLoading}
                                title={this.props.t('campaign.target-content')}
                                emptyPlaceholder={this.props.t('campaign.no-content')}
                                handleDelete={(data) => this.handleTargetContentDeletion(data)}
                                data={this.state.campaign.TargetContent == null ? [] : this.getTargetContentForIds(this.state.campaign.TargetContent.map(content => content.Id))}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }

    endCampaignAlert() {
        return (
            <AlertDialog
                title={this.props.t('common.remove-question')}
                description={this.props.t('common.remove-description')}
                options={[
                    {
                        label: this.props.t('common.cancel'),
                        action: () => this.setState({ endCampaignModalOpen: false })
                    },
                    {
                        label: this.props.t('campaign.end'),
                        action: () => {
                            this.props.endCampaignEarly(this.state.campaignId, (success) => {
                                if (success) {
                                    this.props.history.push(`/campaigns`);
                                }
                            })
                        }
                    }
                ]}
                isOpen={this.state.endCampaignModalOpen}
            />
        );
    }

    render() {

        if (this.state.loading) {
            return <Loading />
        }

        return (
            <div>
                <HeaderBlock
                    title={
                        this.props.currentCampaign.DisplayName
                    }
                    right={
                        <Grid container spacing={2} alignItems="center" justify="flex-end">
                            <Grid item>
                                <ButtonGroup>
                                    {this.state.isEditing ?
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => this.setState({ endCampaignModalOpen: true })}
                                        >
                                            {this.props.t('common.delete')}
                                        </Button> :
                                        null
                                    }
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                            if (this.state.isEditing) {
                                                this.props.updateCampaign(this.state.campaignId, this.state.campaign, () => {
                                                    this.setState({ isEditing: false, campaign: this.props.currentCampaign })
                                                })
                                            } else {
                                                this.setState({ isEditing: true })
                                            }
                                        }}
                                    >
                                        {this.state.isEditing ? this.props.t('common.done') : this.props.t('common.edit')}
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    }
                />

                {this.endCampaignAlert()}

                <TargetGroupPickerModal
                    handleCancel={() => {
                        this.setState({ targetGroupModalOpen: false });
                    }}
                    handleDone={selectedItems => {
                        this.handleTargetGroupSelection(selectedItems);
                    }}
                    open={this.state.targetGroupModalOpen}
                    selected={this.state.campaign.TargetGroups || []}
                />

                <ContentPickerModal
                    handleCancel={() => {
                        this.setState({ targetContentModalOpen: false });
                    }}
                    handleDone={selectedItems => {
                        this.handleTargetContentSelection(selectedItems);
                    }}
                    open={this.state.targetContentModalOpen}
                    cols={2}
                    spacing={8}
                    cellHeight={90}
                    selected={(this.state.campaign.TargetContent || []).map(content => content.Id)}
                />



                <PageContainer>
                    {this.renderData()}
                </PageContainer>
            </div>
        );
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { targetGroups } = state.TargetGroupReducer
    const { files } = state.FileDownloadReducer
    const { currentCampaign } = state.CampaignReducer
    const { mustSells } = state.MustSellReducer
    const { groups } = state.GroupReducer
    const { forms } = state.FormsReducer
    const { objectives } = state.ObjectivesReducer
    const { customerFlags } = state.CustomerFlagReducer
    const { priceLists } = state.PriceListsReducer
    const { dashboardLayouts } = state.DashboardLayoutReducer

    return {
        targetGroups,
        files,
        currentCampaign,
        mustSells,
        groups,
        forms,
        objectives,
        customerFlags,
        priceLists,
        dashboardLayouts
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getCampaign,
            updateCampaign,
            updateLocalCampaign,
            resetLocalCampaign,
            endCampaignEarly,

            getMustSellSkusForIds,
            getFormsForIds,
            getGroupsWithIds,
            getFilesForIds,
            getTargetGroupsForIds,
            getCustomerFlagsForIds,
            getObjectives,
            getPriceLists,
            getDashboardLayoutsByIds
        },
        dispatch
    );

const hoc = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation()(ViewCampaignPage))
);

// EXPORT COMPONENT

export { hoc as ViewCampaignPage };

